import { useState } from "react";
import { useFlagVariant } from "libs/hooks/src";
import { SHORTER_SUF } from "apps/website/components/flows/fresh/sign-up/flags";
import {
  getDefaultCatCount,
} from "apps/website/components/flows/fresh/sign-up/defaults/signupDefaults";

import { CatCount, MAX_CAT_COUNT } from "../constants";

export interface IUseCatCountFormReturn {
  selectedCatCount: CatCount | null;
  setSelectedCatCount: (count: CatCount) => void;
  isValid: () => boolean;
}

export function useCatCountForm(
  initialCatCount: number,
): IUseCatCountFormReturn {
  const isShorterSufTest = useFlagVariant(SHORTER_SUF);
  const defaultCatCount = getDefaultCatCount(isShorterSufTest);

  const getInitialCatCount = (): CatCount | null => {
    if (initialCatCount === 0) {
      return defaultCatCount;
    }
    if (initialCatCount >= MAX_CAT_COUNT) {
      return MAX_CAT_COUNT;
    }
    return initialCatCount as CatCount;
  };

  const [ selectedCatCount, setSelectedCatCount ] = useState<CatCount | null>(getInitialCatCount());

  const isValid = (): boolean => selectedCatCount !== null;

  return {
    selectedCatCount,
    setSelectedCatCount,
    isValid,
  };
}
